import Skeleton, { SkeletonText } from '@components/skeleton';

const SKELETON_ROWS = 4;

export default function EditionsSkeleton(): React.JSX.Element {
  return (
    <>
      <div className="page-header">
        <div className="page-header__left">
          <Skeleton width="160px" height="28px" borderRadius="6px" />
          <Skeleton width="220px" height="16px" borderRadius="4px" />
        </div>
        <div className="page-header__actions">
          <Skeleton width="130px" height="36px" borderRadius="8px" />
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>
                <SkeletonText width="50px" />
              </th>
              <th>
                <SkeletonText width="36px" />
              </th>
              <th>
                <SkeletonText width="56px" />
              </th>
              <th>
                <SkeletonText width="48px" />
              </th>
              <th>
                <SkeletonText width="56px" />
              </th>
              <th style={{ textAlign: 'right' }}>
                <SkeletonText width="56px" />
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: SKELETON_ROWS }, (_, i) => (
              <tr key={`skeleton-row-${i}`}>
                <td>
                  <SkeletonText width={`${120 + (i % 3) * 30}px`} />
                </td>
                <td>
                  <SkeletonText width="40px" />
                </td>
                <td>
                  <SkeletonText width="70px" />
                </td>
                <td>
                  <Skeleton width="52px" height="22px" borderRadius="12px" />
                </td>
                <td>
                  <SkeletonText width="80px" />
                </td>
                <td>
                  <div className="table-actions">
                    {Array.from({ length: 6 }, (_, j) => (
                      <Skeleton key={j} width="28px" height="28px" borderRadius="6px" />
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
